<template>
  <div>
    <AtomsLabel class="mb-1" :is-error="isError">
      <!-- 必須マークは RichTextLabel が擬似要素で質問文の文末に出す。文字列に連結すると見出し・箇条書きの外へ落ちる（JCAT-6058） -->
      <div :class="style({ hasNote })">
        <RichTextLabel v-if="label" class="min-w-0 text-base tracking-normal text-black2" :html="label" :required="required" />
        <!-- 見えるマークは擬似要素で出るため、読み上げ用の文言だけをここに置く -->
        <span v-if="label && required" class="sr-only">(required)</span>
      </div>
      <p v-if="hasNote" class="text-xs tracking-normal text-gray4 md:text-sm" v-html="note"></p>
    </AtomsLabel>
    <slot />
    <AtomsParagraphSub v-if="hasHelperText" class="text-gray2">{{ helperText }}</AtomsParagraphSub>
    <AtomsErrorText v-if="isError" lang="en">{{ error }}</AtomsErrorText>
  </div>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

import RichTextLabel from '@/wabunka-src/common/components/pure/RichTextLabel/RichTextLabel.vue';

interface Props {
  label?: string;
  note?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
}

const props = withDefaults(defineProps<Props>(), {
  required: true,
  label: undefined,
  note: '',
  error: '',
  helperText: '',
});
const hasNote = computed(() => !!props.note && props.note !== '');
const hasHelperText = computed(() => !!props.helperText && props.helperText !== '');
const isError = computed(() => !!props.error && props.error !== '');

/**
 * Style
 */
const style = tv({
  base: 'flex items-end gap-x-2',
  variants: {
    hasNote: {
      true: 'mb-1',
    },
  },
});
</script>
